import { servicesApi } from '@/services/api';

interface VerifyAccountRequest {
  accountId: string;
  email: string;
  website: string;
  privacyPolicyUrl?: string;
  termsOfServiceUrl?: string;
}

export const accountVerificationApi = {
  async verifyAccount({ accountId, email, website, privacyPolicyUrl, termsOfServiceUrl }: VerifyAccountRequest) {
    const body: {
      email: string;
      website: string;
      privacy_policy_url?: string;
      terms_of_service_url?: string;
    } = {
      email,
      website,
    };

    if (privacyPolicyUrl != null) {
      body.privacy_policy_url = privacyPolicyUrl;
    }

    if (termsOfServiceUrl != null) {
      body.terms_of_service_url = termsOfServiceUrl;
    }

    return servicesApi.verifyAccount({
      params: { accountId: Number.parseInt(accountId, 10) },
      body,
    });
  },
};
